import { useClientInfo } from '../containers/providers/Client/clientInfoContext';

const useClientInfoContext = useClientInfo;

export default useClientInfoContext;
